<button
  [ngClass]="buttonClasses"
  (click)="updateCurrentTrigger()"
  id="'formTrigger-'{{ data().step }}"
>
  <h3 class="form-trigger__title">
    {{ data().title }}
    @if (data().step !== FORM_STEP.Four) {
      <app-tooltip
        class="form-trigger__title__icon"
        [text]="data().tooltip!"
        [fontSize]="'14px'"
        [config]="data().tooltipConfig"
      ></app-tooltip>
    }
  </h3>

  @if (showInputElem) {
    <input
      type="text"
      [placeholder]="data().subtitle"
      class="form-trigger__input"
      (input)="updateDropdownValue($event)"
      [(ngModel)]="data()['filter']"
      (click)="handleInputClick($event)"
    />
  } @else {
    <p class="form-trigger__subtitle">{{ data().subtitle }}</p>
  }
</button>

<app-form-builder
  [config]="data().formConfig"
  class="form"
  [class.display]="isActiveStep"
></app-form-builder>
